var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{staticClass:"show-time-btn",attrs:{"variant":"outline-primary m-1 btn-sm position-bottom"},on:{"click":_vm.showClientTime}},[_vm._v("Show Time")])}
var staticRenderFns = []

export { render, staticRenderFns }